import templateUrl from './trip-planner-provider-details.html';

export const tripPlannerProviderDetailsComponent = {
    bindings: {
        details: '<',
        privateTravelTime: '@',
        privateTravelTimeUnit: '@',
        selectedPublicRoute: '<',
        selectedServiceType: '<',
        distance: '@'
    },

    templateUrl,

    controller: class TripPlannerProviderDetailsComponent {

        constructor($filter) {
            'ngInject';

            this.$filter = $filter;
        }

        _getClass(day) {
            return this.details && day ? this.details.daysOfOperation[day] === true ? 'activeDay' : 'inActiveDay' : '';
        }

        _getTime(time) {
			const isMinutesZero = new Date(time).getMinutes() === 0 ? true : false;
			return isMinutesZero ? this.$filter('date')(time,'h a') : this.$filter('date')(time,'h:mm a')
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-provider-details/trip-planner-provider-details.component.js